var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{attrs:{"value":_vm.valor,"max":100,"type":_vm.valor === 100 ? 'is-success' : 'is-primary',"show-value":""}},[_vm._v(_vm._s(_vm.valor)+"%")])
}
var staticRenderFns = []

export { render, staticRenderFns }